// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteShopArticleDigitalAssetByIdRequestModel from '../../model/delete-shop-article-digital-asset-by-id-request-model';
import DeleteShopArticleDigitalAssetByIdRequestDTO from '../dto/delete-shop-article-digital-asset-by-id-request-dto';
import dtoSchema from '../schemas/delete-shop-article-digital-asset-by-id-request-schema';

export default abstract class DeleteShopArticleDigitalAssetByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteShopArticleDigitalAssetByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteShopArticleDigitalAssetByIdRequestDTO>): DeleteShopArticleDigitalAssetByIdRequestModel;
  static toModel(dto: DeepPartial<DeleteShopArticleDigitalAssetByIdRequestDTO> | undefined | null): DeleteShopArticleDigitalAssetByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteShopArticleDigitalAssetByIdRequestDTO> | undefined | null): DeleteShopArticleDigitalAssetByIdRequestModel | undefined {
    return dto ? new DeleteShopArticleDigitalAssetByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteShopArticleDigitalAssetByIdRequestModel> | DeleteShopArticleDigitalAssetByIdRequestModel): DeleteShopArticleDigitalAssetByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteShopArticleDigitalAssetByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteShopArticleDigitalAssetByIdRequestModel, can not map to DeleteShopArticleDigitalAssetByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
